import { useEffect, useState } from 'react';
import AccountPage from '../../Component/Elements/Page/AccountPage/AccountPage';
import BrandInfoSwipeBox from './components/BrandInfoSwipeBox/BrandInfoSwipeBox';
import LoginInputContainer from './components/LoginInputContainer/LoginInputContainer';
import CSS from "./static/css/login.module.css";
import Button from '../../Component/Elements/Button/Normal/Button';
import useIsMobile from '../../Common/hooks/useIsMobile';

function Login() {
    // 모바일 환경에서 소개페이지와 로그인 페이지를 구분하는 페이지 변수
    const [page, setPage] = useState<"" | "brand_info" | "login">("");

    const isMobile = useIsMobile();

    const goToLoginPageHandler = () => {
        setPage("login");
    }

    useEffect(() => {
        if(localStorage.getItem("visited:/Login") === "true"){
            setPage("login");
        }else{
            setPage("brand_info");
            localStorage.setItem("visited:/Login", "true");
        }
    }, []);

    return (
        <AccountPage>
            <div className={CSS.l_Login_main}>
                {
                    isMobile
                    ?   page === "brand_info"
                        ?   <div className={CSS.l_Login_BrandInfoPage}>
                                <div className={CSS.l_Login_BrandInfoSwipeBox}>
                                    <BrandInfoSwipeBox />
                                    <Button onClick={goToLoginPageHandler}>OOPS 시작하기</Button>
                                </div> 
                            </div>
                        :   <div className={CSS.l_Login_LoginInputContainer}>
                                <LoginInputContainer />
                                <BrandInfoSwipeBox version="v2" />
                            </div>
                    :   <>
                            <div className={CSS.l_Login_BrandInfoSwipeBox}>
                                <BrandInfoSwipeBox />
                            </div> 
                            <div className={CSS.l_Login_LoginInputContainer}>
                                <LoginInputContainer />
                            </div>
                        </>
                }
            </div>
        </AccountPage>
    );
}
export default Login;
